export default "__VITE_ASSET__c0vcCV1z__"